import {
  BoxProps,
  HStack,
  RadioGroupProps,
  useRadioGroup,
} from '@chakra-ui/react';
import { SIZE } from '~/constants';

import {
  ISwitchGroupIconOption,
  SwitchGroupOptionType,
} from './SwitchGroup.types';
import { SwitchGroupButton } from './components';

export interface ISwitchGroupProps {
  value?: string;
  name?: string;
  onChange: (value: string) => void;
  options: SwitchGroupOptionType[];
  radioButtonProps?: BoxProps;
  radioGroupProps?: Omit<
    RadioGroupProps,
    'onChange' | 'defualtValue' | 'children'
  >;
  size?: SIZE;
}

export const SwitchGroup: React.FC<ISwitchGroupProps> = ({
  value,
  name,
  onChange,
  options,
  radioButtonProps,
  radioGroupProps,
  size = SIZE.sm,
}) => {
  const { value: defaultValue } =
    options.find(({ isDefault }) => isDefault) ?? {};

  const { getRootProps, getRadioProps } = useRadioGroup({
    defaultValue,
    value,
    onChange,
  });

  const group = getRootProps();

  return (
    <HStack
      display="inline-flex"
      backgroundColor="primary.50"
      spacing={0}
      borderRadius="full"
      padding={1}
      name={name}
      {...group}
      {...radioGroupProps}
    >
      {options.map((option) => {
        const radio = getRadioProps({ value: option.value });
        return (
          <SwitchGroupButton
            key={option.value}
            size={size}
            radioButtonProps={radioButtonProps}
            dataHeapTrack={option.dataHeapTrack}
            {...radio}
            {...(option as ISwitchGroupIconOption)}
          />
        );
      })}
    </HStack>
  );
};
